'use client';

import { useEffect } from 'react';
import { useBreakpoints } from '@/hooks/useBreakpoints';
import useMap from '@/hooks/useMap';
import type { SearchParams } from '@/models/SearchParams';
import { getRightContainerStyles } from '@/utils/calcHeaderHeight';
import { VIEW } from '@/constants/queryConstants';

type Props = {
  isLoggedIn: boolean;
  isNotificationBannerVisible: boolean;
  searchParams: SearchParams;
};

// scroll right till it reaches end in desktop :(
export default function ScrollLockForRightColumnInDesktop({
  isLoggedIn,
  isNotificationBannerVisible,
  searchParams
}: Props) {
  const { isDesktop } = useBreakpoints();
  const { mapExpanded } = useMap();

  useEffect(() => {
    const styles = getRightContainerStyles(isLoggedIn, isNotificationBannerVisible);
    const right = document.getElementById('right');
    if (right && mapExpanded) {
      right.style.top = isDesktop ? `${styles.mapExpanded.top}rem` : `${styles.mapExpanded.mobileTop}rem`;
      right.style.paddingTop = '0px';
      return;
    }

    const top = isDesktop ? styles.mapCollapsed.top : styles.mapCollapsed.mobileTop;
    const topInPx = top * 16;
    const someMorePadding = 50;

    const diff = right ? right.offsetHeight - (window.innerHeight - topInPx + someMorePadding) : -1;
    if (right) {
      if (searchParams.view !== VIEW.FULL_MAP && diff > 0 && isDesktop) {
        right.style.top = `${topInPx - diff}px`;
        right.style.paddingTop = '24px';
      } else {
        right.style.top = `${topInPx}px`;
        right.style.paddingTop = '0px';
      }
    }
  }, [isDesktop, isLoggedIn, isNotificationBannerVisible, mapExpanded, searchParams]);
  return <></>;
}
